<template>
    <div>
        {{ cachedT(`assignment.types.${props.params.value}`) }}
    </div>
</template>

<script setup lang="ts">

import {Assignment} from '@/assignments/Assignment.type'
import {ICellRendererParams} from 'ag-grid-community'
import {useCachedT} from '@/services/useCachedI18n'

const {cachedT} = useCachedT()

const props = defineProps({
    params: {
        type: Object as () => ICellRendererParams<Assignment>,
        required: true
    }
})

</script>

<style scoped>

</style>